import { LocalDate } from '../../../core/model/local-date';
import { ModelBase } from '../../../core/model/model-base';
import { Money } from '../../../core/model/money';
import { ControlDataExportFile } from './control-data-export-file';

export class ControlDataExportForm extends ModelBase {
  constructor() {
    super();
    this.createdAt = new Date();
    this.files = [];
  }

  companyId: string;
  companyName: string;
  incomeYear: number;
  createdAt: Date;
  files: ControlDataExportFile[];
  comment: string;
}
